import { Box } from '@/ui/primitives';
import { InfoOutlinedIcon } from '@/ui/primitives/icons';
import {
  buildChartPanelTitleSx,
  chartPanelTitleInfoIconSx,
  chartPanelTitleTextSx,
} from './chartPanelSurfaceSx';
import type { ReactElement } from 'react';

type ChartPanelTitleProps = {
  title: string;
  component?: 'div' | 'h2' | 'span';
  fontSizePx?: number;
  fontWeight?: number;
  justifyContent?: 'flex-start' | 'center';
  showInfoIcon?: boolean;
};

export const ChartPanelTitle = ({
  title,
  component = 'div',
  fontSizePx = 18,
  fontWeight = 500,
  justifyContent = 'flex-start',
  showInfoIcon = true,
}: ChartPanelTitleProps): ReactElement => (
  <Box
    component={component}
    sx={buildChartPanelTitleSx({ fontSizePx, fontWeight, justifyContent })}
  >
    <Box component="span" sx={chartPanelTitleTextSx}>
      {title}
    </Box>
    {showInfoIcon ? <InfoOutlinedIcon aria-hidden="true" sx={chartPanelTitleInfoIconSx} /> : null}
  </Box>
);
